import { StoreInterface } from "./Store";

export function getUserFromState(state: any){
  const theState = state as StoreInterface;
  return theState.user;
}